import { useTranslation } from 'react-i18next';

import { Field } from 'coreOld/components';
import { Icon } from 'coreOld/elements';
import { InputType, Size } from 'coreOld/enums';
import { partsService } from 'partsOld/services';

import {
  InputWrapper,
  LabelWrapper,
  Wrapper,
  controlStyle,
  iconStyle,
  menuListStyle,
  optionStyle,
} from './partSearchStyle';

interface IProps {
  goToParts: (search?: string) => void;
  onKeyDown: (event: KeyboardEvent, searchText: string) => void;
}

const PartSearchView = ({ goToParts, onKeyDown }: IProps) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <LabelWrapper>{t('messageSearchPartNumber')}</LabelWrapper>

      <InputWrapper>
        <Field
          type={InputType.ASYNC_SELECT}
          name="search"
          inputProps={{
            getOptions: partsService.getManyAutocomplete,
            getLabel: (opt) => [opt?.number, opt?.manufacturerName].join(' | '),
            requestPayload: {
              manufacturerIncluded: 1,
            },
            endIcon: <Icon name={Icon.SEARCH} />,
            onSearchClick: (searchText) => goToParts(searchText),
            onChange: (value) => goToParts(value),
            onKeyDown,
            isClearable: false,
            size: Size.LG,
            fontInherit: true,
            controlStyle: controlStyle,
            optionStyle: optionStyle,
            menuListStyle: menuListStyle,
            iconStyle: iconStyle,
          }}
        />
      </InputWrapper>
    </Wrapper>
  );
};

export default PartSearchView;
